import { teamRoles } from "../../constants/teamRoles";
// import getCollectionData from "../../utils/getCollectionData";
import { getPriceRef, getUserRef } from "../../utils/referenceMappers";
import runTransaction from "../../utils/runTransaction";

// import { DiscussionChannel } from "../discussion/types/DiscussionChannel";
import createProductionPriceData from "../productions/prices/createProductionPriceData";
import createTeamMemberData from "../productions/team/createTeamMemberData";
import createOfferStatusChangedTodoData from "../todos/data/offers/createOfferStatusChangedTodoData";
import addWorkNarrators from "../works/addWorkNarrators";

import offerStatuses from "./constants/offerStatuses";
import getOfferAgreement from "./utils/getOfferAgreement";
import getOfferPrice from "./utils/getOfferPrice";

export const ALREADY_ACCEPTED_ERROR = "Already accepted!";

export default async function acceptOffer(firebase, { offer, user }) {
	const db = firebase.firestore();

	const price = getOfferPrice({ offer, user });
	const agreement = getOfferAgreement({ offer, user });

	return runTransaction(
		firebase,
		[offer.ref, offer.production.ref],
		async (transaction, [transactionOffer, production]) => {
			if (transactionOffer.status === offerStatuses.ACCEPTED) {
				throw ALREADY_ACCEPTED_ERROR;
			}

			const firstParty = agreement?.firstParty || offer.firstParty;
			const secondParty = agreement?.secondParty || offer.secondParty;

			const productionPrice = price
				? createProductionPriceData(firebase, {
						...price,
						expense: true,
						approved: true,
						producer: offer.producer,
						production: offer.production,
						agreement,
						firstParty,
						secondParty,
						referencePrice: price,
				  })
				: null;

			const member = createTeamMemberData(firebase, {
				user,
				offer,
				agreement,
				firstParty,
			});

			if (member.role === teamRoles.READER && production.work) {
				await addWorkNarrators(
					firebase,
					{
						users: [member.user],
						production,
					},
					{ transaction },
				);
			}

			transaction.update(offer.ref, {
				status: offerStatuses.ACCEPTED,
				secondParty: offer.secondParty || getUserRef(user),
			});

			if (productionPrice?.ref && offer.role !== teamRoles.RECORDER) {
				transaction.set(productionPrice.ref, productionPrice);
			}

			transaction.update(offer.production.ref, {
				[`team.${member.id}`]: { ...member, price: getPriceRef(productionPrice) },
			});

			const todo = createOfferStatusChangedTodoData(firebase, {
				status: offerStatuses.ACCEPTED,
				offer: { ...offer, secondParty: offer.secondParty || getUserRef(user) },
			});

			transaction.set(todo.ref, todo);
		},
	);
}
